import * as TRIGGERACTIONS from './triggerActions.constants';
import { TriggerAction } from '../../models';

/** LOAD */
export function loadTriggerActions() {
    return { type: TRIGGERACTIONS.TRIGGER_ACTIONS_LOAD };
}

export function loadTriggerActionsSuccess(data: TriggerAction[]) {
    return { type: TRIGGERACTIONS.TRIGGER_ACTIONS_LOAD_SUCCESS, payload: data };
}

export function loadTriggerActionsError(error: any) {
    return { type: TRIGGERACTIONS.TRIGGER_ACTIONS_LOAD_ERROR, payload: error };
}


/** ADD */
export function addTriggerAction(triggerAction: TriggerAction) {
    return { type: TRIGGERACTIONS.TRIGGER_ACTION_ADD, payload: triggerAction };
}

export function addTriggerActionSuccess(triggerAction: TriggerAction) {
    return { type: TRIGGERACTIONS.TRIGGER_ACTION_ADD_SUCCESS, payload: triggerAction };
}

export function addTriggerActionsError(error: any) {
    return { type: TRIGGERACTIONS.TRIGGER_ACTION_ADD_ERROR, payload: error };
}

/** UPDATE */
export function updateTriggerAction(triggerAction: TriggerAction) {
    return { type: TRIGGERACTIONS.TRIGGER_ACTION_UPDATE, payload: triggerAction };
}

export function updateTriggerActionSuccess(triggerAction: TriggerAction) {
    return { type: TRIGGERACTIONS.TRIGGER_ACTION_UPDATE_SUCCESS, payload: triggerAction };
}

export function updateTriggerActionsError(error: any) {
    return { type: TRIGGERACTIONS.TRIGGER_ACTION_UPDATE_ERROR, payload: error };
}

/** DELETE */
export function deleteTriggerAction(triggerAction: TriggerAction) {
    return { type: TRIGGERACTIONS.TRIGGER_ACTION_DELETE, payload: triggerAction };
}

export function deleteTriggerActionSuccess(triggerAction: TriggerAction) {
    return { type: TRIGGERACTIONS.TRIGGER_ACTION_DELETE_SUCCESS, payload: triggerAction };
}

export function deleteTriggerActionError(error: any) {
    return { type: TRIGGERACTIONS.TRIGGER_ACTION_DELETE_ERROR, payload: error };
}